import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import HeatmapHelperService from '@Pages/Heatmap/HeatmapHelperService';
import BaseHeaderCell from '@Pages/Heatmap/HeatmapTable/Header/BaseHeaderCell';
import { MIN_STRUCTURE_LABEL_SIZE } from '@Pages/Heatmap/HeatmapTable/constants';

function RowHeaderCell({
  index,
  visibleIndex,
  cell,
  height,
  width,
  isRow,
  selectHeaderItem,
  selectedHeaderItems,
  hoveredItem,
  handleHover,
  showStructure,
}) {
  return (
    <BaseHeaderCell
      index={index}
      cell={cell}
      isRow={isRow}
      selectHeaderItem={selectHeaderItem}
      showStructure={showStructure}
      handleHover={handleHover}
      hoveredItem={hoveredItem}
      mainStyle={{
        height: `${height}px`,
        top: `${visibleIndex * height}px`,
        borderTop: selectedHeaderItems.indexOf(index) !== -1 && HeatmapHelperService.getCellBorder(selectedHeaderItems, index, true),
        borderBottom: selectedHeaderItems.indexOf(index) !== -1 && HeatmapHelperService.getCellBorder(selectedHeaderItems, index, false),
      }}
      structureWrapperClassName="heatmap__header__structure-rows-wrapper"
      structureClassName="heatmap__header__structure heatmap__header__text-ellipsize"
      labelClassName="heatmap__header__text-ellipsize"
      mainClassName={classnames({
        heatmap__header: true,
        'heatmap__header--horizontal-selected': selectedHeaderItems.indexOf(index) !== -1,
        'heatmap__header--horizontal-hovered': hoveredItem && hoveredItem.index === index && hoveredItem.showBorder,
      })}
      labelStyle={{}}
      structureLabelStyle={{
        width: `${width - 15}px`, // decrease for padding of the cell
        display: width > MIN_STRUCTURE_LABEL_SIZE ? 'block' : 'none',
      }}
    />
  );
}

RowHeaderCell.propTypes = {
  index: PropTypes.number,
  visibleIndex: PropTypes.number,
  cell: PropTypes.object,
  selectHeaderItem: PropTypes.func,
  selectedHeaderItems: PropTypes.array.isRequired,
  hoveredItem: PropTypes.object,
  showStructure: PropTypes.bool,
  handleHover: PropTypes.func,
  isRow: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default RowHeaderCell;
